module.exports = __webpack_public_path__ + "img/cancel.ee325f22.svg";